const LOG_REPORT_URL = 'https://publicservice-logserver.xunkaish.com/';
const LOG_TOPIC = 'log_gapp_web';

export default class Log {
  constructor(config) {
    if (!config) {
      console.warn('上报自动根据运行环境适配');
    }
    this.session_id = this.generateUUID();
    // 默认值，可以被覆盖
    this.commonInfo = {
      os: 'h5',
      platform: 'h5'
    };
    this.debug = config.debug || false;
    this.reportHandlerType = config.reportHandlerType || undefined;
    if (typeof config.commonInfo === 'function') {
      this.commonInfo = { ...this.commonInfo, ...config.commonInfo() };
    } else if (Object.prototype.toString.call(config.commonInfo) === '[object Object]') {
      this.commonInfo = { ...this.commonInfo, ...(config.commonInfo || {}) };
    }
    this.extend_info = this.commonInfo.extend_info || {};
    delete this.commonInfo.extend_info;
  }

  getRefer() {
    return window && window.location && window.location.href;
  }

  generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

  getDefaultField() {
    // 默认字段：上报配置字段和动态生成字段，不允许修改
    return {
      topic: LOG_TOPIC,
      protocol_version: '2.0',
      session_id: this.session_id,
      log_id: this.generateUUID(),
      event_time: new Date().getTime()
      // referer: this.getRefer()
    };
  }

  // 需要动态注入的属性
  // app_version app_subversion os_version device_mode device_manu	device_brand

  // 发行Gapp应用
  isGapp() {
    return /qapp/i.test(navigator && navigator.userAgent);
  }

  // 微信小程序
  isMiniProgram() {
    // if (typeof wx === 'object' && typeof wx.canIUse === 'function') {
    //   return true;
    // }
  }

  report(data, extend_info) {
    // 验证上报数据格式
    if (!data || Object.prototype.toString.call(data) !== '[object Object]') {
      console.error('上报失败：data 为必传参数，且必须为 object 对象');
      return;
    }
    if (data && data.extend_info && Object.prototype.toString.call(data.extend_info) !== '[object Object]') {
      console.error('上报失败：data.extend_info 必须为 object 对象');
      return;
    }
    if (extend_info && Object.prototype.toString.call(extend_info) !== '[object Object]') {
      console.error('上报失败：extend_info 必须为 object 对象');
      return;
    }

    let mergedData = { ...data, ...this.commonInfo, ...this.getDefaultField() };
    // 验证上报必填字段，可以从构造函数传入，或者上报时指定
    if (!mergedData.app || !mergedData.page || !mergedData.event || !mergedData.action) {
      console.error('data 必须包含以下字段： app,page,event,action');
      return;
    }

    mergedData.extend_info = { ...this.extend_info, ...mergedData.extend_info };

    if (extend_info && typeof extend_info === 'object') {
      mergedData.extend_info = { ...mergedData.extend_info, ...extend_info };
    }

    let handler = this.getReportHandler();
    if (this.debug) {
      console.log(`上报的数据为：${JSON.stringify(mergedData)}`);
    }
    return handler(mergedData);
  }

  getReportHandler() {
    let handlers = this.reportHandler();
    // 指定上报类型，直接使用该类型上报。
    if (this.reportHandlerType) {
      let handle = handlers[this.reportHandlerType];
      if (!handle) {
        console.warn(`无法找到${this.reportHandlerType}上报处理方法，将会使用默认 webReport`);
        handle = handlers['webReport'];
      }
      return handle;
    }
    // 没有指定上报类型，根据运行环境判断
    if (this.isMiniProgram()) {
      return handlers['miniProgramReport'];
    }
    if (this.isGapp()) {
      return handlers['gappReport'];
    }

    return handlers['webReport'];
  }

  // 上报处理程序
  reportHandler() {
    let self = this;
    return {
      gappReport: function(data) {
        //GAPP 使用webReport
        this.webReport(data);
      },
      webReport: function(data) {
        try {
          let paramStr = self.getParam(data);
          new Image().src = `${LOG_REPORT_URL}?${paramStr}`;
        } catch (err) {
          console.error(err);
        }
      },
      miniProgramReport: function() {
        // wx.request({
        //   url: LOG_REPORT_URL,
        //   data: {
        //     ...data
        //   }
        // });
      }
    };
  }

  getParam(data) {
    let paramArray = [];
    let keys = Object.keys(data);
    keys.forEach(function(key) {
      if (Object.prototype.toString.call(data[key]) === '[object Object]') {
        data[key] = JSON.stringify(data[key]);
      }
      paramArray.push(key + '=' + encodeURIComponent(data[key]));
    });
    return paramArray.join('&');
  }
}
